import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import '@round/ui-kit/dist/esm/index.css';
import '@round/auth/dist/esm/index.css';
import 'flag-icons/css/flag-icons.min.css';
import { createRoot } from 'react-dom/client';
import { configureApi } from '@round/api';
import { installPreloadErrorHandler } from '@round/utils';

import './index.css';
import App from './App';

import { datadogLogs } from '@datadog/browser-logs';
import { FeatureFlagsProvider } from './utility/featureFlags/FeatureFlagsContext';

configureApi({ origin: import.meta.env.VITE_API_DOMAIN ?? '' });

if (import.meta.env.PROD && import.meta.env.VITE_DATADOG_TOKEN && import.meta.env.VITE_DATADOG_SITE_NAME) {
    datadogLogs.init({
        clientToken: import.meta.env.VITE_DATADOG_TOKEN,
        site: import.meta.env.VITE_DATADOG_SITE_NAME,
        forwardErrorsToLogs: true,
        sampleRate: 100,
    });
}

installPreloadErrorHandler({ onError: (error) => console.error('[preloadError]', error) });

const root = createRoot(document.getElementById('root')!);
root.render(
    <FeatureFlagsProvider>
        <App />
    </FeatureFlagsProvider>
);
